import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { US_COUNTRY_CODE, UserRegion } from "./UserContext";
import { UserContextLoader } from "./user-context-loader";
import { PortalAccount } from "../../feature/account/PortalAccount";

@Injectable({ providedIn: 'root' })
export class UserContextProvider {

    constructor(private userContextLoader: UserContextLoader) {
        this.userContextLoader.load();
    }

    public get isContextLoaded(): boolean {
        return this.userContextLoader.userContext.contextLoaded.value;
    }

    public get isContextLoaded$(): BehaviorSubject<boolean> {
        return this.userContextLoader.userContext.contextLoaded;
    }

    public get currencyCode(): string {
        return this.userContextLoader.userContext.currencyCode.value;
    }

    public get currencyCode$(): BehaviorSubject<string> {
        return this.userContextLoader.userContext.currencyCode;
    }

    public get localeCode(): string {
        return this.userContextLoader.userContext.localeCode.value;
    }

    public get localeCode$(): BehaviorSubject<string> {
        return this.userContextLoader.userContext.localeCode;
    }

    public get region(): UserRegion {
        if(this.userContextLoader.userContext.region.value == null) {
            return UserRegion.NA;
        }

        return this.userContextLoader.userContext.region.value;
    }

    public isNaUser(): boolean {
        return this.userContextLoader.userContext.region.value == UserRegion.NA;
    }

    public isEuUser(): boolean {
        return this.userContextLoader.userContext.region.value == UserRegion.EU;
    }
   
    public get account(): PortalAccount | undefined {
        return this.userContextLoader.userContext.portalAccount.value;
    }

    public get account$(): BehaviorSubject<PortalAccount | undefined> {
        return this.userContextLoader.userContext.portalAccount;
    }

    public get countryCode(): string {
        if(this.userContextLoader.userContext.countryCode.value == null) {
            return US_COUNTRY_CODE;
        }

        return this.userContextLoader.userContext.countryCode.value;
    }

    public get countryCode$(): BehaviorSubject<string | undefined> {
        return this.userContextLoader.userContext.countryCode;
    }

    public get countryName(): string | undefined {
        return this.userContextLoader.userContext.countryName.value;
    }

    public get token(): string | undefined {
        return this.userContextLoader.userContext.portalAccount.value?.token;
    }
}